// ABOUTME: The thinking watchdog's silence beat — flashes the Cavalry Error shape, then rests.
// ABOUTME: Pure factory so App.js stays frozen and the beat's contract is unit-testable.

/**
 * Builds the `onSilence` handler the thinking watchdog fires when the agent never
 * answers a turn (declined gibberish, cut-off speech, true silence).
 *
 * The beat (2026-09-01): flash the rig's authored Error shape for the reaction window
 * so a dead turn reads as "didn't catch that" instead of the visualizer silently giving
 * up, then rest the transport state as before. It rides the same reaction channel as
 * cart/wishlist — but the resolver deliberately lets any live voice outrank 'error'
 * (see voiceVisualizerState.js precedence), so a late agent answer or the guest trying
 * again takes the screen instantly.
 *
 * Both collaborators are mount-stable in App.js (`triggerReaction` closes over a ref and
 * a setState; `setAgentState` is a setState), which is what lets the caller memoize the
 * returned handler with an empty dependency list — useThinkingWatchdog re-arms its timer
 * on identity change, so a per-render identity would restart the 4s window every render.
 */
export function makeThinkingSilenceHandler({ triggerReaction, setAgentState }) {
  return function handleThinkingSilence() {
    triggerReaction('error');
    // 'listening' is the transport's own resting value (what the agent-finished path
    // sets), which the visualizer resolver maps to 'idle'. Deliberately not a new
    // agentState value — the status-text call sites branch on this string.
    setAgentState('listening');
  };
}

export default makeThinkingSilenceHandler;
